
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import {
  CcdlButtonComponent,
  CcdlCardComponent,
  CcdlInputComponent,
} from '@cpm-pr1618001/ng-design-lib';

@Component({
  selector: 'about-us-ui',
  templateUrl: './about-us.component.html',
  styleUrl: './about-us.component.scss',
  imports: [
    CcdlButtonComponent,
    CcdlInputComponent,
    CcdlCardComponent
],
  standalone: true,
})
export class AboutUsComponent implements OnInit {
  fg: FormGroup;

  ngOnInit(): void {
    this.fg = new FormGroup({
      firstName: new FormControl(),
      lastName: new FormControl(),
      emailAddress: new FormControl(),
      helpTextField: new FormControl(),
    });
  }

  getControl(controlName: string): FormControl {
    return this.fg.get(controlName) as FormControl;
  }
}
